module.exports = __webpack_public_path__ + "static/media/bg1.6b1983a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg1.jpg
// module id = 3532
// module chunks = 0